import cqrsApiService from "../../../shared/services/cqrsApiService.js";

export default {
  fetchAll(vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/Instruments/FindAll", vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  delete(vm, id) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Instruments/delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  create(vm, domainModel) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Instruments/create", { instrument: domainModel }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  edit(vm, domainModel) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Instruments/edit", { instrument: domainModel }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  }
}